<template>
  <div class="i-header">
    <div class="logo">
      <img src="../../assets/img/logo.png" alt>
    </div>
    <div class="loginBtn">
      <el-menu class="docMenu" mode="horizontal">
        <el-submenu index="1">
          <template slot="title"><span>{{$t("index.documentation")}}</span></template>
          <el-menu-item index="1-1"><a href="../../static/apidoc/docs.html" target="_blank">API</a></el-menu-item>
          <el-submenu class="subMenu" index="1-2">
            <template slot="title">SDK</template>
            <el-menu-item index="1-2-1"><a href="https://github.com/wanchain/iWan-js-sdk" target="_blank">JavaScript</a></el-menu-item>
            <el-menu-item index="1-2-2"><a href="https://github.com/wanchain/iWan-java-sdk" target="_blank">Java</a></el-menu-item>
          </el-submenu>
        </el-submenu>
      </el-menu>
      <router-link to="/login" class="login">{{$t("index.login")}}</router-link>
      <router-link to="/register" class="goRe">{{$t("index.signup")}}</router-link>
    </div>
  </div>
</template>
<script>
export default {
  components: {}
};
</script>

<style lang="scss">
.qiang{
  color: red;
}
.docMenu {
  > .el-submenu {
    > .el-submenu__title {
      padding: 0px;
    }
    .el-submenu__title:hover {
      border: none;
      background: transparent;
      opacity: 0.7;
    }
    span {
      color: white;
    }
    .el-icon-caret-bottom {
      color: white !important;
      &:before {
        content: "\E600";
      }
    }
  }
  .el-submenu {
    > .el-menu {
      top: 20px;
      left: 0px;
      border: none;
      background-color: rgba(42, 35, 35, .3);
      min-width: 130px;
      width: 130px;
    }
    .el-submenu__icon-arrow {
      margin-left: 7px;
      margin-top: 4px;
    }
  }
  .subMenu {
    .el-submenu__title {
      padding: 0px 10px;
      line-height: 36px !important;
    }
    > .el-submenu__title {
      font-size: 14px !important;
      display: inline-block;
      width: 100%;
    }
    .el-submenu__icon-arrow {
      position: absolute;
      margin-top: -7px !important;
      right: 10px;
    }
    >.el-menu {
      top: -6px;
      left: 130px !important;
    }
    .el-icon-caret-bottom:before {
      content: "\E602";
    }
  }
  .el-submenu__title {
    color: white;
    border: none !important;
    height: 100% !important;
    line-height: 16px !important;
    font-size: 16px;
    &:hover {
      background: rgba(42, 35, 35, .7);
    }
  }
}
</style>

<style lang="scss" scoped>
.docMenu {
  display: inline-block;
  background: transparent;
  color: white;
  top: 2px;
  .el-submenu {
    text-align: left;
    .el-menu-item {
      text-align: left;
      background-color: transparent;
      min-width: 130px;
      &:hover {
        background-color: rgba(42, 35, 35, .7);
      }
    }
  }
  > .el-submenu {
    > .el-menu a {
      font-size: 14px !important;
      display: inline-block;
      width: 100%;
    }
  }
  .subMenu {
    width: 100%;
    height: 36px;
    line-height: 36px;
    a {
      font-size: 14px !important;
      display: inline-block;
      width: 100%;
    }
  }
}
.i-header .loginBtn a.login {
  margin-right: 30px;
}


.i-header {
  width: 100%;
  height: 90px;
  line-height: 90px;
  text-align: center;
  margin: 0 auto;
  display: inline-block;
  background: #06102e;
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: 0px 2px 10px 0px rgba(9, 45, 105, 0.04);
  .logo {
    float: left;
    img {
      width: 110px;
      padding: 0px;
      vertical-align: middle;
      margin-left: 30px;
    }
  }
  .loginBtn {
    float: right;
    /* a:hover {
      text-decoration: underline;
    } */
    a {
      padding: 8px 12px;
      color: #fff;
      font-size: 16px;
      margin: 0 130px 0 0;
      text-decoration: none;
    }
    .el-submenu {
      a {
        padding: 0px;
      }
    }
    .goRe {
      background-image: linear-gradient(90deg, #e6c680 0%, #f1e0bc 100%);
      border-radius: 34px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Header.vue?fd477aa2